import * as React from 'react';

import cx from 'classnames';

// @ts-ignore
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Header from 'components/Header';
import Link from 'components/Link';

import './styles/MarketingLayout.scss';

type Props = {
  location: any;
  children?: React.ReactNode;
  borderless?: boolean;
};

function MarketingLayout(props: Props) {
  return (
    <div className="MarketingLayout">
      <div className="MarketingLayout-headerContainer">
        <div
          className={cx('MarketingLayout-header', {
            'MarketingLayout-header--border': !props.borderless,
          })}>
          <Header data-test="header" location={props.location} />
        </div>
      </div>
      <div className="MarketingLayout-content">
        <div className="MarketingLayout-content-inner">
          <BoxBody flush>{props.children}</BoxBody>

          {CurrentUser.isSignedIn() ? (
            <BoxFooter>
              {`Logged in as ${CurrentUser.getUser().getSignature()}`}
              <br />
              Not you? <Link onClick={() => AuthActions.signOut(undefined, true)}>Log out</Link>
            </BoxFooter>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default MarketingLayout;
